import currency from 'currency.js';

export function formatCurrency(value: number, opts: { isCentValue?: boolean; showEuroSign?: boolean } = {}) {
  let { isCentValue = true, showEuroSign = true } = opts;
  let amount = isCentValue ? value / 100 : value;

  return currency(amount, {
    symbol: showEuroSign ? '€ ' : '',
    separator: '.',
    decimal: ',',
  })
    .format()
    .trim();
}
